import * as ex from "excalibur";
import { Resources } from "../Resources";
import { Player } from "../player";
import { Grandpa } from "../actors/characters/grandpa";

import { goToScene } from "../main";
import Computer from "../actors/computer";
import CutSceneManager from "../cutSceneManager";
import { playerState } from "../state/stateManager";
import { getHouseContent } from "../content/houseContent";
import { createGainedItem, createNotification } from "../utils";

export class House extends ex.Scene {
  constructor() {
    super();
    const player = new Player(4 * 16, 21 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.z = 4;
    // let notice = new ex.Actor({
    //   pos: new ex.Vector(20 * 16, 7 * 16),
    //   height: 24,
    //   width: 100,
    //   color: ex.Color.fromHex("#80530f"),
    // });
    const grandpa = new Grandpa(15 * 16, 16 * 16);
    this.grandpa = grandpa;
    grandpa.z = 3;
    this.computerCollision = false;
    this.cutSceneBoolean = false;
  }
  startCutscene() {
    this.player.cutScene = true;
    this.cutSceneBoolean = true;
    this.cutScene = new CutSceneManager(
      [
        { action: "move", content: 20, direction: "right" },
        { action: "dialog", content: "firstTestDialog" },
        { action: "move", content: 20, direction: "left" },
        { action: "dialog", content: "firstTestDialog" },
      ],
      this.grandpa,
      this.player,
      () => {
        console.log("cutscene: endScene()");
        this.cutSceneBoolean = false;
        this.cutScene = null;
        this.player.cutScene = false;
        this.grandpa.cutScene = false;
      }
    );
    this.cutScene.startScene();
  }
  onInitialize(engine) {
    Resources.HouseMap.addToScene(this);
    this.computer = new Computer();
    this.add(this.computer);

    this.player.wearingVeil = false;
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.add(this.grandpa);
    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.strategy.lockToActorAxis(this.player, ex.Axis.Y);
    this.camera.zoom = 1;
    this.door = new ex.Trigger({
      pos: new ex.Vector(5 * 16, 23 * 16),
      width: 32,
      height: 16,
      target: this.player,
      action: () => {
        goToScene("home", { x: 7 * 16, y: 13 * 16 });
      },
    });
    this.add(this.door);
    this.bedCollider = new ex.Actor({
      x: 10 * 16,
      y: 4 * 16,
      height: 64,
      width: 16,
      collisionType: ex.CollisionType.Passive,
      name: "bedCollider",
    });
    this.add(this.bedCollider);

    this.player.on("collisionstart", (e) => {
      console.log("collisionhouse: ", e);
      if (e.other.owner.name === "computerCollider") {
        console.log("collided with computer");
        this.computerCollision = true;
      } else if (e.other.owner.name == "grandpa") {
        console.log("grandpaCollision");

        this.grandpa.startInteraction(this.player.lastDir, this.player);
      } else if (e.other.owner.name == "bedCollider") {
        this.computerCollision = false;
        this.bedCollision = true;
        this.createPopup();
      }
    });
    this.player.on("collisionend", (e) => {
      if (e.other.owner.name === "computerCollider") {
        console.log("end collision computer");
        this.computerCollision = false;
      } else if (e.other.owner.name === "bedCollider") {
        this.bedCollision = false;
        this.destroyNotification();
      }
    });
  }
  createPopup() {
    this.indicationShowing = true;
    this.noti = createNotification("Space: Rest").create();
  }
  destroyNotification() {
    this.indicationShowing = false;
    createNotification().destroy();
  }
  onActivate() {
    this.content = playerState.getContent();
    if (!this.content.houseIntro.viewed) {
      this.player.lastDir = "up";
      this.grandpa.graphic = "down-idle";
      this.player.cutScene = true;
      this.grandpa.cutScene = true;
      this.player.pos.x = 14 * 16;
      this.player.pos.y = 20 * 16;
      Resources.Footsteps.stop();
      this.startHouseIntroScene();
    }
  }
  startHouseIntroScene() {
    let player = playerState.getPlayer();
    this.cutSceneBoolean = true;
    let con = getHouseContent(player.name, "BoBees").getHouseIntro();
    console.log("introContent: ", con);
    this.cutScene = new CutSceneManager(con, this.grandpa, this.player, () => {
      this.player.cutScene = false;
      this.player.wearingVeil = true;
      this.grandpa.cutScene = false;
      let content = playerState.getContent();
      content.houseIntro.viewed = true;
      content.houseIntro.should = false;
      this.cutSceneBoolean = false;
      createGainedItem(`Grandpa's Smoker`);
    });
    this.cutScene.startScene();
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
      if (this.computerCollision) {
        console.log("pressed space, should go");
        goToScene("onlineMarket");
      } else if (this.bedCollision) {
        let rest = document.getElementById("rest");
        Resources.Crickets.play();
        this.destroyNotification();
        rest.classList.remove("notResting");
        rest.classList.add("resting");
        this.player.cutScene = true;
        let content = playerState.getContent();
        content.stings.count = 0;
        content.stings.stings = [];
        playerState.setContent(content);
        setTimeout(() => {
          this.player.cutScene = false;
          rest.classList.remove("resting");
          rest.classList.add("notResting");
          Resources.Crickets.stop();
        }, 3000);
      }
    }
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Enter)) {
      if (this.cutSceneBoolean) {
        this.cutScene.enterPress();
      }
    }
  }
}
